import Link from 'next/link';

const SOCIAL_LINKS = [
  { href: 'https://x.com/irmatokenai', icon: 'fa-x-twitter', label: 'X' },
  { href: 'https://www.instagram.com/irmaplatform', icon: 'fa-instagram', label: 'Instagram' },
  { href: 'https://fb.me/irmaplatform', icon: 'fa-facebook', label: 'Facebook' },
  { href: 'https://www.linkedin.com/showcase/irma-platform/', icon: 'fa-linkedin', label: 'LinkedIn' },
  { href: 'https://www.tiktok.com/@irmatoken.ai', icon: 'fa-tiktok', label: 'TikTok' },
  { href: 'https://t.me/+xRsx4LPxvII4YjQx', icon: 'fa-telegram', label: 'Telegram' },
  { href: 'https://discord.gg/Xuucak6CWU', icon: 'fa-discord', label: 'Discord' },
  { href: 'https://youtube.com/@irmatokenai', icon: 'fa-youtube', label: 'YouTube' },
];

export function Footer() {
  return (
    <footer className="relative z-10 border-t border-white/10 bg-[#0a0d14]/80 backdrop-blur-sm mt-16">
      <div className="max-w-6xl mx-auto px-6 py-10">
        {/* Disclaimer */}
        <div className="mb-8">
          <h4 className="text-sm font-bold text-white/90 mb-2">Disclaimer:</h4>
          <p className="text-sm text-white/50 leading-relaxed">
            Investments on the IRMA platform are subject to market risks. Tokenized real-world assets may
            fluctuate in value and returns are not guaranteed. Please review our terms before participating.
          </p>
        </div>

        {/* Follow Us */}
        <div className="mb-8">
          <h4 className="text-sm font-bold text-white/90 mb-3">Follow Us:</h4>
          <div className="flex flex-wrap gap-3">
            {SOCIAL_LINKS.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                className="flex items-center justify-center w-10 h-10 rounded-full bg-white/5 border border-white/10 text-white/60 hover:text-[#25e4e8] hover:border-[#25e4e8]/30 hover:bg-[#25e4e8]/10 transition-all"
              >
                <i className={`fab ${social.icon} text-sm`} />
              </a>
            ))}
          </div>
        </div>

        {/* Divider */}
        <hr className="border-white/10 mb-6" />

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-white/40">
          <span>IRMA&copy; All rights reserved</span>
          <div className="flex items-center gap-3">
            <Link href="/terms-and-conditions" className="hover:text-[#25e4e8] transition-colors">
              T&C&apos;s
            </Link>
            <span className="text-white/20">|</span>
            <Link href="/privacy-policy" className="hover:text-[#25e4e8] transition-colors">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>

      {/* Font Awesome CDN for social icons */}
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
      />
    </footer>
  );
}
